// removed by extract-text-webpack-plugin
module.exports = {"media-react-player-wrap-wrap":"media-react-player-wrap-wrap___FzjYv center___2iqBf","media-react-player-wrap":"media-react-player-wrap___2pE_W"};